export default __webpack_public_path__ + "static/media/pt-img.e6d23454.webp";